import { Link, useLocation } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BsFillGearFill, BsChevronRight } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import {
  faLaptopMedical,
  faStethoscope,
  faStar,
  faHome,
  faUserDoctor,
  faUserNurse,
  faHospitalUser,
  faUsersRays,
  faComments,
  faRightFromBracket,
  faBan,
  faFlask,
  faChartLine,
  faBullhorn,
} from '@fortawesome/free-solid-svg-icons';
import { logout } from '../../../../reducer/authentication';
import { RootState } from '../../../../store';
import classes from './style.module.scss';

library.add(
  faStethoscope,
  faLaptopMedical,
  faHome,
  faUserDoctor,
  faUserNurse,
  faHospitalUser,
  faUsersRays,
  faComments,
  faRightFromBracket,
  faBan,
  faFlask
);

const Sidebar = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.authentication);

  return (
    <div className={classes.leftsideBar}>
      <div className={classes.appiconCnt}>
        <div className={classes.appicon}>
          <FontAwesomeIcon icon="stethoscope" />
        </div>
        <h1>CAREIPRO</h1>
      </div>

      <ul>
        <li>
          <Link to="/" className={pathname === '/' ? classes.active : ''}>
            <FontAwesomeIcon icon="home" />
            <span>Home</span>
          </Link>
        </li>
        <li>
          <Link
            to="/patients"
            className={pathname.includes('/patients') ? classes.active : ''}
          >
            <FontAwesomeIcon icon="hospital-user" />
            <span>Patients</span>
          </Link>
        </li>
        <li>
          <Link
            to="/doctors"
            className={pathname.includes('/doctors') ? classes.active : ''}
          >
            <FontAwesomeIcon icon="user-doctor" />
            <span>Doctors</span>
          </Link>
        </li>
        {/* the lab is granted per clinic from branch management. a clinic with nothing saved does
            not get it, so the setting has to be on rather than merely not off */}
        {user?.clinic_settings?.show_lab_module === true &&
          <li>
            <Link
              to="/lab"
              className={pathname.includes('/lab') ? classes.active : ''}
            >
              <FontAwesomeIcon icon={faFlask} />
              <span>Laboratory</span>
            </Link>
          </li>}
        <li>
          <Link
            to="/rating-reviews"
            className={
              pathname.includes('/rating-reviews') ? classes.active : ''
            }
          >
            <FontAwesomeIcon icon={faComments} />
            <span>Rating & reviews</span>
          </Link>
        </li>
        <li>
          <Link
            to="/ad-campaigns"
            className={pathname.includes('/ad-campaigns') ? classes.active : ''}
          >
            <FontAwesomeIcon icon={faBullhorn} />
            <span>Ad Campaigns</span>
          </Link>
        </li>
        <li>
          <Link
            to="/visiters-report"
            className={
              pathname.includes('/visiters-report') ? classes.active : ''
            }
          >
            <FontAwesomeIcon icon={faChartLine} />
            <span>Visit report</span>
          </Link>
        </li>
        <li>
          <a href='javascript:void(0)' className={pathname.includes('/transactions') ? classes.active : ''}>
            <FontAwesomeIcon icon={faStar} />
            <span>Transactions</span>
            <BsChevronRight className='ml-auto' />
          </a>
          <ul>
            <li>
              <Link
                to="/transactions/sms-transaction"
                className={
                  pathname.includes('/transactions/sms-transaction')
                    ? classes.active
                    : ''
                }
              >
                <span>SMS Transaction</span>
              </Link>
            </li>
            <li>
              <Link
                to="/transactions/online-payments"
                className={
                  pathname.includes('/transactions/online-payments')
                    ? classes.active
                    : ''
                }
              >
                <span>Appointment Booking</span>
              </Link>
            </li>
            <li>
              <Link
                to="/transactions/invoices"
                className={
                  pathname.includes('/transactions/invoices')
                    ? classes.active
                    : ''
                }
              >
                <span>Invoices</span>
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <Link
            to="/staffs"
            className={pathname.includes('/staffs') ? classes.active : ''}
          >
            <FontAwesomeIcon icon="user-nurse" />
            <span>Staffs</span>
          </Link>
        </li>
        {/* the block list is an admin only screen, the route is not mounted for anyone else */}
        {user?.role === 'admin' &&
          <li>
            <Link
              to="/blocked-numbers"
              className={pathname.includes('/blocked-numbers') ? classes.active : ''}
            >
              <FontAwesomeIcon icon="ban" />
              <span>Blocked Numbers</span>
            </Link>
          </li>}
        <li>
          <a href='javascript:void(0)' className={pathname.includes('/settings') ? classes.active : ''}>
            <BsFillGearFill />
            <span>Settings</span>
            <BsChevronRight className='ml-auto' />
          </a>
          <ul>
            <li>
              {/* the settings page itself, holding Services and Prescription Print */}
              <Link
                to="/settings"
                className={pathname === '/settings' ? classes.active : ''}
              >
                <span>Clinic Settings</span>
              </Link>
            </li>
            <li>
              <Link
                to="/settings/banners"
                className={pathname.includes('/settings/banners') ? classes.active : ''}
              >
                <span>Banners</span>
              </Link>
            </li>
            <li>
              <Link
                to="/settings/clinic-info"
                className={pathname.includes('/settings/clinic-info') ? classes.active : ''}
              >
                <span>Clinic Info</span>
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};
export default Sidebar;
